module.exports = __webpack_public_path__ + "img/photo_bs.64e28462.png";